export const SEARCH_TOOL_NAME = "search";
export const SAVE_ENTITY_TOOL_NAME = "save_entity";
export const RESOURCE_TOOL_NAME = "read_resource";

export const REASONING_EXACT_THRESHOLD_MS = 5000;
export const PREVIEW_MIN_MS = 600;
export const NOW_TICK_MS = 150;
